import { camelCase } from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import randomBytes from 'randombytes';

export const generateId = (len = 16): string => randomBytes(len).toString('hex');

// generate building block _id field
export const generateElementId = (): string => uuidv4();

/**
 * generate building block uiConfig.nodeProps.id field
 * @param id {string} building block _id field value
 * @param name {string} building block name field
 * @return {string}
 */
export const generateNodeId = (id: ReturnType<typeof generateElementId>, name: string): string =>
	`${camelCase(name).toLowerCase()}-${id}`;

export const generateCardId = () => generateId(4);

export const generateCardEventId = () => generateId(4);

export const generateStepId = () => generateId(4);
